// extracted by mini-css-extract-plugin
export default {"container":"InternetConection_container__ltm0g"};